import Checkbox from "../../../../../components/common/Checkbox/Checkbox"
import DatatableComponent from "../../../../../components/common/DatatableComponent/DatatableComponent"
import YellowHeaderWrapper from "../../../../../components/common/YellowHeaderWrapper/YellowHeaderWrapper"
import styles from "./RoleAndPermissions.module.scss"

const RoleAndPermissions = () => {
  const data = [
    { role: "Administrator" },
    { role: "Inventory Manager" },
    { role: "Order Processor" },
    { role: "Customer Service" },
    { role: "Marketing Manager" },
  ]

  const columns = [
    { name: "Role", selector: (row) => row.role },
    { name: "Manage Products", cell: () => <Checkbox />, center: true },
    { name: "Process Orders", cell: () => <Checkbox />, center: true },
    { name: "Customer Service", cell: () => <Checkbox />, center: true },
    { name: "Financial Reports", cell: () => <Checkbox />, center: true },
    { name: "Marketing", cell: () => <Checkbox />, center: true },
  ]

  const listItems = [
    `Each row represents a different user role within the seller's team.`,
    `Each column represents a key area of the seller's business operations, such as managing products, processing orders, and accessing financial reports.`,
    `Checkmarks indicate which areas of the business a user with a given role can access or manage.`,
  ]

  return (
    <div className="mt-3">
      <YellowHeaderWrapper title={"Role and Permissions"}>
        <DatatableComponent data={data} columns={columns} type={"gray"} />
      </YellowHeaderWrapper>
      <div className="p-2 bg-white mt-3">
        <div className={styles["wrapper"]}>
          <div className="fw-semibold fs-5">Guidelines</div>

          <ul className="mb-0">
            {listItems.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  )
}

export default RoleAndPermissions
